module.exports = __webpack_public_path__ + "static/media/kicbac_logo.e4ef1fc8.svg";